import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  manage() {
    if (typeof window.Truendo?.openCookieSettings !== "function") {
      console.error("truendo: cookie settings unavailable")
      return
    }

    window.Truendo.openCookieSettings()
  }
}
